import {
  GET_COORDINATION_FAIL,
  GET_COORDINATION_SUCCESS,
  GET_COORDINATIONS_FAIL,
  GET_COORDINATIONS_SUCCESS,
  ADD_COORDINATION_SUCCESS,
  ADD_COORDINATION_FAIL,
  UPDATE_COORDINATION_SUCCESS,
  UPDATE_COORDINATION_FAIL,
  DELETE_COORDINATION_SUCCESS,
  DELETE_COORDINATION_FAIL,  
  SET_STATE_COORDINATION
} from "./actionTypes";

const INIT_STATE = {
  coordinations: [],
  coordination: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const coordinations = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_COORDINATIONS_SUCCESS:
      return {
        ...state,
        coordinations: action.payload.coordinations,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_COORDINATION:
      return { ...state, loading: action.payload }

    case GET_COORDINATIONS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_COORDINATION_SUCCESS:
      return {
        ...state,
        coordinations: [...state.coordinations, action.payload],
      };

    case ADD_COORDINATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_COORDINATION_SUCCESS:
      return {
        ...state,
        coordinations: state.coordinations.map(coordination =>
          coordination.id.toString() === action.payload.id.toString()
            ? { ...action.payload, coordination }
            : coordination
        ),
      };

    case UPDATE_COORDINATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_COORDINATION_SUCCESS:
      return {
        ...state,
        coordinations: state.coordinations.filter(
          coordination => coordination.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_COORDINATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_COORDINATION_SUCCESS:
      return {
        ...state,
        coordination: action.payload,
      };

    case GET_COORDINATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default coordinations;
